import {Vendor} from "../../models/misc.model";

export const VENDOR_FEATURE = 'vendors';

export interface VendorState {
  vendors: Vendor[];
}
